module.exports = "# Module 2 Overview\n\n#### At a glance\n##### Duration: 20-60 minutes depending on activities used\n* Watch engaging videos.\n* Sing the *H2Whoa!* Theme Song.\n* Play a game show about water sources and different things that pollute water.\n* Write a poem about water.\n* Be assigned their second mission.\n\n#### Key Vocabulary\n* Pollution\n* Water Sources\n\n# Materials\n\n#### What you need for this level\n* Each Apprentice requires their signed Mission Page\n"


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoaHybrid/sections/00_prep/level2_prep.md
// module id = 1720
// module chunks = 2